import { axios } from "@/libraries/axios";
import { AxiosError } from "axios";
import debounce from "lodash/debounce";
import {
	applyPromotion,
	applyPromotionFailure,
	applyPromotionSuccess,
	fetchPrePaymentData,
	fetchPrePaymentDataFailure,
	fetchPrePaymentDataSuccess,
	proceedPayment,
	proceedPaymentFailure,
	proceedPaymentSuccess,
	selectProduct,
	selectProductFailure,
	selectProductSuccess,
	triggerCancel,
} from "../reducers/payment";

// async function prePaymentListener({ payload }: any, { dispatch }: any) {
//   const res = await axios.get('/api/v1/checkouts', payload)

//   console.log(data[status]);

//   if (ok) {
//     dispatch(fetchPrePaymentDataSuccess({data}))
//   } else {
//     // const errorMessage = `${data.status}: ${data.error}`
//     dispatch(fetchPrePaymentDataFailure({error: status}))
//   }
// }

async function prePaymentListener({ payload }: any, { dispatch }: any) {
	try {
		const response = await axios.get("/api/v1/checkouts", {
			params: payload,
		});
		const { data } = response;
		dispatch(fetchPrePaymentDataSuccess({ data }));
	} catch (error) {
		if (error instanceof AxiosError) {
			dispatch(
				fetchPrePaymentDataFailure({
					error: `error ${error.status} : ${error.response?.data?.errors}`,
				}),
			);
		}
	}
}

async function selectProductListener({ payload }: any, { dispatch }: any) {
	try {
		const res = await axios.post("/api/v1/checkouts/select-product", payload);
		dispatch(selectProductSuccess(res.data));
		payload.callback?.();
	} catch (error) {
		if (error instanceof AxiosError) {
			dispatch(selectProductFailure(error.response?.data));
		}
	}
}

async function applyPromotionListener({ payload }: any, { dispatch }: any) {
	try {
		const res = await axios.post("/api/v1/checkouts/apply-promotion", payload);
		dispatch(applyPromotionSuccess({ data: res.data }));
		payload.callback?.();
	} catch (error) {
		if (error instanceof AxiosError) {
			dispatch(applyPromotionFailure({ error: error.response?.data }));
		}
	}
}

async function checkoutListener({ payload }: any, { dispatch }: any) {
	try {
		const res = await axios.post("/api/v1/checkouts/proceed");
		dispatch(proceedPaymentSuccess(res.data));
		payload.callback?.([res.data.data.checkout_url]);
	} catch (error) {
		if (error instanceof AxiosError) {
			dispatch(
				proceedPaymentFailure({
					message: "Network error or invalid request",
				}),
			);
		}
	}
}

async function cancelListener() {
	await axios.post("/api/v1/checkouts/cancel");
}

export default function rootListener(listen: any) {
	listen(fetchPrePaymentData, debounce(prePaymentListener, 100));
	listen(selectProduct, debounce(selectProductListener, 100));
	listen(applyPromotion, debounce(applyPromotionListener, 100));
	listen(proceedPayment, debounce(checkoutListener, 100));
	listen(triggerCancel, debounce(cancelListener, 100));
}
